import React, { useState, useEffect } from "react";
import Select2 from "react-select2-wrapper";
import "select2/dist/css/select2.min.css";
import { getUserColor, getShortLetters } from "../../utils/function";
import { UTILS } from "../../constants";
import axios from "axios";
export const MemberList = ({ cardDetail, updateMemnbers, closeModal }) => {
  const [assigned_users, setAssigned_users] = useState([]);
  const [unassigned_users, setUnassigned_users] = useState([]);

  useEffect(() => {
    setAssigned_users(cardDetail?.assigned_users);
    setUnassigned_users(cardDetail?.unassigned_users);
  }, [cardDetail?.assigned_users]);

  const handleAssignMember = (memberId, assignId) => {
    const randomString = Math.random().toString(36).substring(2, 5);
    const formData = new FormData();
    formData.append("task_id", cardDetail.id);
    formData.append("member_id", memberId);
    formData.append("assigned", assignId);
    axios
      .post(
        `${UTILS.API_url}board/v1/board-list-cards/assign-unassign-member?${randomString}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("trelloToken")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((response) => {
        setAssigned_users(response.data.assigned_users);
        setUnassigned_users(response.data.unassigned_users);
        updateMemnbers(response.data.assigned_users);

        // console.log("Member_successfully:", response.data.assigned_users);
        // setUpdateAssign(response.data.board_list_card);
        // toast.success(response.data.success);
      })
      .catch((error) => {
        console.error("Error assigning/unassigning member:", error);
      });
  };

  const shiftMember = (client, type = 0) => {
    // 0 = means assign to unassign
    // 1 = menas unassign to assign.

    if (type == 1) {
      setAssigned_users((prevArray) => [...prevArray, client]);
      const temp = unassigned_users.filter((user) => user.id !== client.id);
      setUnassigned_users(temp);
      // updateMemnbers(assigned_users);
    }

    if (type == 0) {
      setUnassigned_users((prevArray) => [...prevArray, client]);
      const temp = assigned_users.filter((user) => user.id !== client.id);
      setAssigned_users(temp);
      // updateMemnbers(assigned_users);
    }
  };

  const [searchInput, setSearchInput] = useState("");

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
  };

  const filteredAssignUsers = assigned_users.filter((user) =>
    user.name.toLowerCase().includes(searchInput.toLowerCase())
  );

  const filteredUnassignUsers = unassigned_users.filter((user) =>
    user.name.toLowerCase().includes(searchInput.toLowerCase())
  );

  return (
    <div className="add-member">
      <button
        className="close-btn-pop close-member"
        onClick={() => closeModal()}
      >
        <span className="material-symbols-outlined">close</span>
      </button>
      <h4 className="mem-heading">Members</h4>

      <div className="form-group">
        <input
          type="text"
          className="form-control"
          aria-describedby="searchHelp"
          placeholder="Search members"
          value={searchInput}
          onChange={handleSearchChange}
        />
      </div>

      <div className="card-members">
        <h4 className="bm-heading">Task Members</h4>
        <div className="sletmem-prof">
          <ul className="card-member-assignment member-assignment">
            {filteredAssignUsers?.length > 0
              ? filteredAssignUsers?.map((client) => (
                  <li
                    key={client.id}
                    className="remove-card-member-list assigned-card-members my-2"
                    style={{ cursor: "pointer" }}
                    data-title={client.name}
                    onClick={() => {
                      handleAssignMember(client.id, 0);
                      shiftMember(client, 0);
                      // setSearchInput("");
                    }}
                  >
                    <span
                      className={`nameCir color${getUserColor(client.name)}`}
                    >
                      {getShortLetters(client.name)}
                    </span>
                    <div className="membr-list-name">{client.name}</div>
                  </li>
                ))
              : null}
          </ul>
        </div>
      </div>
      <div className="board-members">
        <h4 className="bm-heading"> Members </h4>
        <div className="sletmem-prof">
          <ul
            className="board-members-list member-assignment"
            style={{ height: "250px", overflowY: "auto" }}
          >
            {filteredUnassignUsers?.length > 0
              ? filteredUnassignUsers?.map((client) => {
                  return (
                    <li
                      className="assign-unassign-members"
                      id={client.id}
                      key={client.id}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        handleAssignMember(client.id, 1);
                        // setSearchInput("");
                        shiftMember(client, 1);
                      }}
                    >
                      <span
                        className={`nameCir color${getUserColor(client.name)}`}
                      >
                        {getShortLetters(client.name)}
                      </span>
                      <div className="membr-list-name">{client.name}</div>
                    </li>
                  );
                })
              : null}
          </ul>
        </div>
      </div>
    </div>
  );
};
